import {FlowModule} from '@fantasmagames/slot/src/modules/flow/FlowModule';
import {IEventManagerWithAsync} from '@fantasmagames/core/src/events/_interfaces/IEventManager';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {Action} from '@fantasmagames/slot/src/logic/Action';
import {FlowWinningState} from '@fantasmagames/slot/src/modules/flow/states/FlowWinningState';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';
import {BigWinEvents} from '@fantasmagames/slot/src/modules/bigwin/BigWinEvents';

export class FlowFreeSpinsState extends FlowWinningState {

	constructor(module: FlowModule, name: string, eventManager: IEventManagerWithAsync) {
		super(module, name, eventManager);
	}

	public onEnterState(): void {
		if (!(this.module.logic.hasRestore && this.module.isRestoreMessageOnTheScreen)) {
			this.emit(FlowModuleEvents.CAN_SPIN);
		}
	}

	protected setupEvents(): void {
		this.on(ReelsEvents.SPIN_ENDED, this.onAllReelsStopped);
		this.on(AvalancheReelsEvents.SYMBOLS_RESPIN_FINISHED, this.onAllReelsStopped);

		this.on(FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
	}

	protected hasAnyBeforeWinFeatures(): boolean {
		return false;
	}

	protected addBeforeWinFeatures(): void {
	}

	protected onFreeSpinsIntroFinished(): void {
		this.emit(FlowModuleEvents.CAN_SPIN);
	}

	protected onAllReelsStopped(): void {
		this._queueEvents.clearEventsQueue();

		if (this.hasAnyBeforeWinFeatures()) {
			this.addBeforeWinFeatures();
		} else {
			this.decideOnNextAction();
		}
	}

	protected decideOnNextAction(): void {
		this._queueEvents.clearEventsQueue();
		switch (this.module.logic.nextAction) {
			case Action.FREESPIN: {
				this.setupNextStateFreeSpinFlow();
				break;
			}
			case Action.SPIN: {
				this.setupNextStateSpinFlow();
				break;
			}

			case Action.PICK: {
				this.setupNextStatePickFlow();
				break;
			}

			case Action.AVALANCHE: {
				this.setupNextStateAvalancheFlow();
				break;
			}

			case Action.RESPIN: {
				this.setupNextRespinFlow();
				break;
			}

			case Action.SCATTER_AND_AVALANCHE: {
				this.handleScatterAvalancheNextState();
				break;
			}

			case Action.EXPLOSION: {
				this.handleExplosionNextState();
				break;
			}

			default:
				this.setupOtherActions(this.module.logic.nextAction);
				break;
		}
	}

	protected setupOtherActions(nextAction: string): void {

	}

	protected setupNextStatePickFlow(): void {
		this.emit(FlowModuleEvents.BONUS_GAME_WON);
	}

	protected setupNextStateSpinFlow(): void {
		if (this.isBigWin()) {
			this.setupBigWin();
			this.addCheckForExitFreeSpin();
		} else if (this.isSpinWin()) {
			this.setupWin();
			this.addCheckForExitFreeSpin();
		} else {
			this.setupNoWin();
			this.gotoBasicState();
		}
	}

	protected addCheckForExitFreeSpin(): void {
		if (this.module.logic.isFreeSpinsStarted && this.module.logic.freeSpinsLeft <= 0) {
			this._queueEvents.addFunctionCallingEventToWaitingList(
				WinPresentationEvents.INITIAL_ANIMATION_FINISHED,
				this.gotoBasicState.bind(this),
			);
		}
	}

	protected setupNextRespinFlow(): void {
		this.emitDelayed(FlowModuleEvents.RESPIN_WON);
		this.module.gotoState(FlowModule.RESPIN_STATE);
	}

	protected handleScatterAvalancheNextState(): void {
		throw new Error('FlowFreeSpinsState::setupExplosionNextState explosion handling must be implemented');
	}

	protected handleExplosionNextState(): void {
		throw new Error('FlowFreeSpinsState::setupExplosionNextState explosion handling must be implemented');
	}

	protected setupNextStateAvalancheFlow(): void {
		this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents.AVALANCHE_WON, () => {
			this.module.gotoState(FlowModule.AVALANCHE_STATE);
		});
		if (this.isBigWin()) {
			this.setupBigWinNoIndividualNoSpin();
			this._queueEvents.addEventToWaitingList(WinPresentationEvents.INITIAL_ANIMATION_STARTED, FlowModuleEvents.AVALANCHE_WON);
		} else if (this.isSpinWin()) {
			this.setupCantSpinWin();
			this._queueEvents.addEventToWaitingList(WinPresentationEvents.INITIAL_ANIMATION_STARTED, FlowModuleEvents.AVALANCHE_WON);
		} else {
			this.emit(FlowModuleEvents.AVALANCHE_WON);
			this.setupCantSpinNoWin();
		}
	}

	protected setupNextStateFreeSpinFlow(): void {
		if (this.isBigWin()) {
			this.setupBigWin();
		} else if (this.isSpinWin()) {
			this.setupWin();
		} else {
			this.setupNoWin();
		}
	}

	protected setupNoWin(): void {
		this.emit(FlowModuleEvents.NO_WIN);
		this.sendOutCanSpin();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/flow/states/FlowFreeSpinsState.ts